import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ObservableBackendService } from './observableBackend.service';
import { ActionAllowed } from '../domain/actionAllowed';
import { URLSearchParams } from "@angular/http";
import { Page } from "../domain/page";
import { Tabs } from "../tabs/tabs.component";


@Injectable()
export class TabSelectedService {

    
    private activeTab: string;
    
    constructor( private backendService: ObservableBackendService ) {
    }
    
    public setActiveTab(tabName: string): void{
        this.activeTab = tabName;
    }
    
    public getActiveTab(): string{
        return this.activeTab;
    }
    
}



/** WEBPACK FOOTER **
 ** ./src/app/service/tabSelected.service.ts
 **/